<template>
  <div>
    <v-app-bar app>
      <v-app-bar-nav-icon
        v-if="connected && !isPublicRoute"
        @click="drawer = !drawer"
      />
      <v-spacer></v-spacer>
      <dark-mode-switch />
      <file-upload-icon v-if="connected && !isPublicRoute" />
      <bell-icon v-if="connected && !isPublicRoute" />
    </v-app-bar>
    <v-navigation-drawer
      app
      v-model="drawer"
      v-if="connected && !isPublicRoute"
      width="300"
    >
      <v-list dense class="pt-2" subheader nav>
        <logo></logo>
        <v-divider></v-divider>

        <!-- Avoid v-if with v-for -->
        <template v-for="(entry, i) in menuEntries">
          <!-- Normal Menü -->
          <v-list-item
            :key="i"
            v-if="!entry.submenu"
            @click="pushRoute(entry)"
            :class="{ 'v-list-item--active': $route.name === entry.route.name }"
          >
            <v-list-item-icon>
              <v-badge
                color="error"
                :value="
                  entry.route &&
                  entry.route.name === 'chat' &&
                  $store.getters.unreadMessages
                "
              >
                <template #badge>
                  <span>{{ $store.getters.unreadMessages }}</span>
                </template>
                <v-icon>{{ entry.icon }}</v-icon>
              </v-badge>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ entry.title }}
                <v-icon v-if="entry.experimental">mdi-test-tube</v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Alt Menü -->
          <v-list-group v-else :key="i" no-action :prepend-icon="entry.icon">
            <template #activator>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ entry.title }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>

            <v-list-item
              v-for="(subEntry, j) in entry.submenu"
              :key="j"
              @click="pushRoute(subEntry)"
              :class="{
                'v-list-item--active': $route.name === subEntry.route.name,
              }"
            >
              <v-list-item-icon>
                <v-icon>{{ subEntry.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ subEntry.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  components: {
    DarkModeSwitch: () => import("@/components/DarkModeSwitch"),
    BellIcon: () => import("@/components/BellIcon"),
    FileUploadIcon: () => import("@/components/FileUploadIcon"),
    Logo: () => import("@/components/Logo"),
    ServerSelection: () => import("@/components/ServerSelection"),
  },
  data() {
    return {
      mini: true,
      drawer: null,
      menuEntries: [
        { title: "Sunucu Listesi", icon: "dns", route: { name: "servers" } },
        {
          title: "Sunucu Görüntüle",
          icon: "remove_red_eye",
          route: { name: "serverviewer" },
        },
        {
          title: "Sunucu Banner",
          icon: "mdi-image-outline",
          route: { name: "serverbanner" },
        },
        {
          title: "Oto Bot",
          icon: "mdi-robot",
          route: { name: "bot" },
        },
        { title: "Sohbet", icon: "mail_outline", route: { name: "chat" } },
        {
          title: "Dosya Yöneticisi",
          icon: "mdi-folder",
          route: { name: "files" },
        },

        {
          title: "Sunucu Günlükleri",
          icon: "mdi-file-document-outline",
          route: { name: "logs" },
        },
        {
          title: "Yedekle / Geri Yükle",
          icon: "settings_backup_restore",
          route: { name: "snapshot" },
        },
        {
          title: "ServerQuery Konsolu",
          icon: "mdi-console",
          route: { name: "console" },
        },
        {
          title: "Yetki Anahtarları",
          icon: "mdi-key",
          route: { name: "tokens" },
        },
        {
          title: "API Anahtarları",
          icon: "mdi-shield-key",
          route: { name: "apikeys" },
        },
        {
          title: "Ban Listesi",
          icon: "not_interested",
          route: { name: "bans" },
        },
        {
          title: "Şikayet Listesi",
          icon: "warning",
          route: { name: "complaints" },
        },

        {
          title: "Tüm Kullanıcılar",
          icon: "person",
          route: { name: "clients" },
        },
        {
          title: "Sunucu Grupları",
          icon: "group",
          route: { name: "servergroups" },
        },
        {
          title: "Kanal Grupları",
          icon: "mdi-hexagon-slice-4",
          route: { name: "channelgroups" },
        },

        {
          title: "Yetkiler",
          icon: "mdi-format-section",
          submenu: [
            {
              title: "Sunucu Grubu",
              icon: "group",
              route: { name: "permissions-servergroup" },
            },
            {
              title: "Kullanıcı Yetkileri",
              icon: "person",
              route: { name: "permissions-client" },
            },
            {
              title: "Kanal Yetkileri",
              icon: "mdi-hexagon-slice-4",
              route: { name: "permissions-channel" },
            },
            {
              title: "Kanal Grupları",
              icon: "mdi-hexagon-slice-4",
              route: { name: "permissions-channelgroup" },
            },
            {
              title: "Kanal-Kullanıcı Yetkileri",
              icon: "mdi-hexagon-slice-4",
              route: { name: "permissions-channelclient" },
            },
          ],
        },

        { title: "Çıkış Yap", icon: "exit_to_app", route: { name: "logout" } },
      ],
    };
  },
  computed: {
    connected() {
      return this.$store.state.query.connected;
    },
    isPublicRoute() {
      return (
        this.$route &&
        this.$route.path &&
        this.$route.path.startsWith("/public/")
      );
    },
  },
  watch: {
    isPublicRoute(v) {
      if (v) this.drawer = false;
    },
  },
  methods: {
    pushRoute(entry) {
      if (entry.route.name !== this.$route.name) {
        this.$router.push(entry.route);
      }
    },
  },
};
</script>
